// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import { store } from './store/index.js'
import axios from 'axios'

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.BASE_URL
/* eslint-disable no-new */
// Option A: Simple global function (easiest)
window.appNavigate = (path) => {
  // Make sure 'router' is accessible
  // → usually import { useRouter } from 'vue-router' in composition API
  // or this.$router in options API

  if (window.__vueRouterInstance) {
    window.__vueRouterInstance.push(path)
  } else if (window.__vueApp._context.components.RouterView) {
    // fallback if you have access to app instance
    const router = window.__vueApp.config.globalProperties.$router
    if (router) router.push(path)
  } else {
    console.warn('Vue Router not found for navigation')
  }
}
window.__vueRouterInstance = router

new Vue({
  el: '#app',
  store: store,
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js